/**
 * Action для полного сброса Redux store
 * Используется при logout для очистки всех данных
 */
export const RESET_STORE = 'RESET_STORE';

export const resetStore = () => ({
    type: RESET_STORE,
});

